export const CONCESSION_STATUS_COLORS: Record<string, { label: string; className: string }> = {
  draft: { label: 'Draft', className: 'bg-gray-50 !text-gray-700 border-gray-300' },
  submitted: { label: 'Submitted', className: 'bg-blue-50 !text-blue-700 border-blue-300' },
  under_review: { label: 'Under Review', className: 'bg-yellow-50 !text-yellow-700 border-yellow-300' },
  approved: { label: 'Approved', className: 'bg-green-50 !text-green-700 border-green-300' },
  rejected: { label: 'Rejected', className: 'bg-red-50 !text-red-700 border-red-300' },
  closed: { label: 'Closed', className: 'bg-purple-50 !text-purple-700 border-purple-300' },
};

export const RISK_LEVEL_COLORS: Record<string, { label: string; className: string }> = {
  low: { label: 'Low', className: 'bg-green-50 !text-green-700 border-green-300' },
  medium: { label: 'Medium', className: 'bg-yellow-50 !text-yellow-700 border-yellow-300' },
  high: { label: 'High', className: 'bg-orange-50 !text-orange-700 border-orange-300' },
  critical: { label: 'Critical', className: 'bg-red-50 !text-red-700 border-red-300' },
};

export const DEVIATION_TYPE_LABELS: Record<string, string> = {
  dimensional: 'Dimensional',
  cosmetic: 'Cosmetic',
  material: 'Material',
  process: 'Process',
  documentation: 'Documentation',
  packaging: 'Packaging',
  other: 'Other',
};

export const FIELD_MAPPING: Record<string, string> = {
  id: 'id',
  concession_number: 'concession_number',
  customer_name: 'customer__name',
  supplier_name: 'supplier__name',
  part_number: 'part_number',
  requested_date: 'requested_date',
  status: 'status',
  risk_level: 'risk_level',
};
